import { BaseClient } from '@carvana/analytics';

export default class SafeBaseClient extends BaseClient {
  /* maybe don't throw 'not implemented' exceptions in middleware */

  constructor(type, config) {
    super(type, config);
  }

  trackEvent = async (eventName, eventData = {}, log, noPublish) => {
    /* don't throw error */
  };

  trackUser = async (eventName, eventData = {}, log, noPublish) => {
    /* don't throw error */
  };

  trackConversion = async (eventName, eventData, log, noPublish) => {
    /* don't throw error */
  };

  trackException = async (eventName, eventData, log, noPublish) => {
    /* don't throw error */
  };

  trackMetric = async (eventName, eventData, log, noPublish) => {
    /* don't throw error */
  };

  methodDoesntExist = name => {
    /* don't throw error */
  };
}
